module.exports = __webpack_public_path__ + "media/tags/smartsearch/orange-arrow-76d43fdf90b1a7d9eefb8804fe1704d9.png";